import { render, staticRenderFns } from "./area-skeleton.vue?vue&type=template&id=289ae04d&scoped=true&"
import script from "./area-skeleton.vue?vue&type=script&lang=js&"
export * from "./area-skeleton.vue?vue&type=script&lang=js&"
import style0 from "./area-skeleton.vue?vue&type=style&index=0&id=289ae04d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289ae04d",
  null
  
)

export default component.exports